import React from 'react';
import { Link } from "react-router-dom";
import connect from "../../assets/about/connect.jpg";
import empower from "../../assets/about/empower.jpg";
import explore from "../../assets/about/explore.jpg";
import group from "../../assets/about/group.jpg";
import logo from "../../assets/about/logo.jpg";
import mobile from "../../assets/about/mobile.jpg";
import Footer from "../footer/Footer";
import BackToTop from "../common/BackToTop";
import StickyNavHeader from "../header/StickyNavHeader";


export default function Header() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <div className="flex flex-col w-full">
      {/* Header Section */}
      <StickyNavHeader />

      <div className="w-full bg-green-50 flex items-center justify-center">
        <div className="container mx-auto py-12 px-4 text-center">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">About Us</h1>
        </div>
      </div>

      {/* About Section */}
      <div className="container mx-auto px-4 py-12 md:py-20" id="about-section">
        <div className="flex flex-col md:flex-row gap-8 items-start">
          <div className="md:w-1/2 space-y-6 md:mt-40">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
              Kaha: Revolutionizing Nepal's Digital Landscape
            </h2>
            <p className="text-base md:text-lg text-gray-600">
              Kaha is a comprehensive digital platform aimed at revolutionizing
              Nepal's digital landscape via digital profiling, digital community
              building, sustainable tourism, and heritage preservation.
            </p>
            <p className="text-base md:text-lg text-gray-600">
              We digitize landmarks, institutions, communities, and businesses
              around the country by integrating advanced tools and technologies.
              The app increases visibility and is accessible to everyone in
              Nepal and globally.
            </p>
          </div>

          <div className="md:w-1/2">
            <img
              src={group}
              alt="Collage of Nepal's digital landscape"
              width={600}
              height={600}
              className="rounded-3xl w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>

      {/* Story Section */}
      <div className="container mx-auto px-4 py-16" >
      <div className="text-center space-y-6">
          <h2 className="text-4xl font-bold text-gray-900">
            The Story of Kaha:
            <br />
            <span className="mt-2 block">
              Connecting Hearts and Heritage in Nepal
            </span>
          </h2>

          <div className="flex justify-center">
            <p className="text-lg text-gray-600 text-left">
              Nestled amidst the majestic Himalayas, Nepal is a land steeped in
              rich culture, breathtaking landscapes, and vibrant communities.
              Yet, for many, navigating this diverse tapestry is a challenge.
              Kaha bridges the gap between people and their surroundings,
              becoming your gateway to a connected Nepal.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 mt-10">
            <div className="bg-[#4CAF50] rounded-2xl p-8 text-white flex-1">
              <h3 className="text-xl font-bold text-white mb-4">
                Humble Beginnings
              </h3>
              <p className="text-base leading-relaxed">
                Our story began with a small team passionate about exploring
                their own country. We saw hidden gems in bustling cities,
                ancient stories whispered by age-old temples, and the warmth of
                local communities waiting to be discovered. But there was a
                disconnect. Tourists often missed the soul of Nepal, and locals
                lacked a platform to share their stories.
              </p>
            </div>

            <div className="border-2 border-gray-200 rounded-2xl p-8 flex-1">
              <h3 className="text-xl font-bold text-[#4CAF50] mb-4">
                Building a Bridge
              </h3>
              <p className="text-base leading-relaxed text-gray-600">
                Kaha empowers exploration, fosters understanding, and celebrates
                Nepal's unique spirit. We collaborate with residents to document
                their history, traditions, and favorite hidden spots.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 md:py-24">
        <div className="grid gap-8 md:grid-cols-2 items-center">
          <div className="relative h-[385px] md:h-[385px] rounded-lg overflow-hidden">
            <div className="w-full h-full bg-gray-100 flex items-center justify-center">
              <img
                src={mobile}
                alt="Mobile showing the app"
                className="w-full h-full object-cover"
                width={500}
                height={450}
              />
            </div>
          </div>
          <div className="space-y-6">
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900">
              More than an App
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              Kaha is a community, a platform for fostering connections and
              creating lasting memories. We simplify your journey with KahaTAGs
              - a unique feature that lets you personalize your experience and
              share it with others.
            </p>
          </div>
        </div>
      </div>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
            Brand Value: Our Values
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-md p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-6">
              <img
                src={connect}
                alt="Connect"
                className="w-full h-full object-cover"
                width={50}
                height={50}
              />
                {/* <svg
                  className="w-full h-full text-green-600"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm6 10a3 3 0 1 0-3-3 3 3 0 0 0 3 3zM6 21a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm6-4a3 3 0 1 0-3-3 3 3 0 0 0 3 3z" />
                </svg> */}
              </div>
              <h3 className="text-xl font-bold mb-4">Connect</h3>
              <p className="text-gray-600 leading-relaxed">
                Build relationships, discover hidden gems, and experience Nepal
                together.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-6">
                {/* <svg
                  className="w-full h-full text-green-600"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z" />
                </svg> */}
                <img
                src={explore}
                alt="Connect"
                className="w-full h-full object-cover"
                width={50}
                height={50}
              />
              </div>
              <h3 className="text-xl font-bold mb-4">Explore</h3>
              <p className="text-gray-600 leading-relaxed">
                Dive into Nepal's rich culture, tradition, and heritage,
                unlocking local authenticity.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-6">
                {/* <svg
                  className="w-full h-full text-green-600"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-7-2h2v-4h4v-2h-4V7h-2v4H8v2h4z" />
                </svg> */}
                <img
                src={empower}
                alt="Connect"
                className="w-full h-full object-cover"
                width={50}
                height={50}
              />
              </div>
              <h3 className="text-xl font-bold mb-4">Empower</h3>
              <p className="text-gray-600 leading-relaxed">
                Streamline your life with KahaTAG, forge your way, and build
                lasting connections.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <BackToTop />
    </div>
  );
}
